var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4999",
    "data-name": "Group 4999",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    width: 36,
    height: 36,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M11.456,7.5h.129a.764.764,0,0,1,.76.688l.7,6.954,4.964,2.837a.764.764,0,0,1,.385.664v.321a.584.584,0,0,1-.737.563L10.593,17.6a.764.764,0,0,1-.561-.8l.661-8.6A.764.764,0,0,1,11.456,7.5Z",
    transform: "translate(5.3 3.963)",
    fill: "#4a4a59",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M10.766,3.678A16.028,16.028,0,1,1,1.595,14.106l2.943.826a12.975,12.975,0,1,0,8.305-8.779l1.82,2.169a.764.764,0,0,1-.542,1.254L6.682,10a.764.764,0,0,1-.787-.94L7.62,1.827a.764.764,0,0,1,1.329-.314Z",
    transform: "translate(0.528 0.655)",
    fill: "#4a4a59",
    fillRule: "evenodd",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.942281ec23ea4ae85f4d5256dafb2787.svg";
export { ForwardRef as ReactComponent };